import MrclText from "../../marcel/MrclText";
import styled from "styled-components";
import { customElement } from "../../marcel/customElement";
import { COLORS } from "../../../utils/colors";

export const BodyRow = styled.tr<{ $variant: "type" | "secteur" | "rayon" | "sous-rayon" | "default"; $clickable: boolean, $index: number | undefined  }>`
  background: ${({ $variant, $index }) => 
    typeof $index === "number" 
      ? ($index % 2 === 0 ? "white" : "#f5faff") 
      : ($variant === "type" ? "#E8F8FF" : $variant === "secteur" ? COLORS.bg_green : $variant === "rayon" ? "#FFFAF0" : "#F5FAFF")
  };

  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;



export const FootText = styled.span`
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0em;
  color: #696969;
`;


export const Card = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: 1px solid #e2e8f0;
  max-width: 100%;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #fafafa;
  flex-wrap: wrap;
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const LegendDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
`;

export const ToolbarActions = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const BaseHeadCell = styled.th`
  padding: 10px 16px;
  text-align: right;
  color: #454545;
  letter-spacing: 0.06em;
  white-space: nowrap;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
  font-weight: 700;
  font-style: normal;
  font-size: var(--font-size-body-m, 16px);
  line-height: var(--line-height-body-m, 24px);
  letter-spacing: var(--letter-spacing-normal, normal);
`;

export const EmptyHeadCell = styled(BaseHeadCell)`
  padding: 0px;
`;

export const HierarchyHeadCell = styled(BaseHeadCell)`
  text-align: left;
  min-width: 220px;
`;

export const HeadCell = styled(BaseHeadCell)`

  text-transform: uppercase;

`;

export const HierarchyCell = styled.td`
  padding: 10px 12px 10px 12px;
`;

export const HierarchyContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ChevronContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ChevronSpacer = styled.span`
  width: 14px;
  display: inline-block;
`;

export const MetricCell = styled.td`
  padding: 10px 16px;
  text-align: right;
  white-space: nowrap;
`;

export const MetricText = styled(MrclText)`
  margin: 0;
  fontWeight: "regular";
  color: #374151;
  font-weight: 400;
  font-style: normal;
  font-size: var(--font-size-body-m, 16px);
  line-height: var(--line-height-body-m, 24px);
  letter-spacing: var(--letter-spacing-normal, normal);

`;

export const EmptyState = styled.div`
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fafafa;
`;

export const CButtonCustom = styled(customElement("mrcl-button"))`
  font-size: 12px;
`;

// Text-link look: mrcl-button styles its inner button from Marcel tokens inside
// its Shadow DOM, so override the tokens rather than the host's own styles.
export const LegendToggle = styled(customElement("mrcl-button"))`
  --mrcl-body-m-bold: 500 12px/16px var(--mrcl-font-family-default);
  --mrcl-sizing-3xl: auto;
  --mrcl-spacing-s: 0;
  --mrcl-spacing-l: 0;
  --mrcl-action-content-neutral-default: #4f46e5;
  --mrcl-action-content-neutral-hover: #4f46e5;
`;
